import { defineStore } from 'pinia'

export interface IActionDef {
  label: string
  type: string // button,...
  callback: () => void
  loading?: boolean
  hidden?: boolean
  disabled?: boolean
  buttonType: string // primary, error,... for type button
}

export interface ITabDef {
  label: string
  value: string
  disabled?: boolean
  reg?: string
}

export interface IActiveTabDef {
  tab: string
  component: string
}

export interface INavBarState {
  tabDefs: ITabDef[]
  actionDefs: IActionDef[]
}

export const useNavBarStore = defineStore('navBar', {
  state: (): INavBarState & { activeTabs: IActiveTabDef[]; currentTab: string } => ({
    actionDefs: [],
    tabDefs: [],
    activeTabs: [],
    currentTab: '',
  }),
  actions: {
    setActionDefs(actionDefs: IActionDef[]) {
      this.actionDefs = actionDefs
    },
    setTabDefs(data: { tabs: ITabDef[]; component?: string }) {
      if (data.tabs.length && data.component) {
        let tab = this.getActiveTab(data.component || '')
        if (!tab || !data.tabs.find((t) => t.value === tab)) {
          tab = data.tabs[0].value
        }
        this.setActiveTab({ tab, component: data.component })
      } else {
        this.currentTab = ''
      }
      this.tabDefs = data.tabs
    },
    setActiveTab(activeTab: IActiveTabDef) {
      const curActiveTab = this.activeTabs.find((t) => t.component === activeTab.component)
      if (curActiveTab) {
        curActiveTab.tab = activeTab.tab
      } else {
        this.activeTabs.push(activeTab)
      }
      this.currentTab = activeTab.tab
    },
    getActiveTab(component: string): string {
      const activeTab = this.activeTabs.find((t) => t.component === component)
      return (activeTab && activeTab.tab) || ''
    },
  },
})
